export const convertTo12HourFormat = (time24) => {
    const [hours, minutes, seconds] = time24.split(":");
    const date = new Date();
    date.setHours(hours, minutes, seconds);

    return date.toLocaleTimeString([], {
        hour: '2-digit',
        minute: '2-digit',
        hour12: true
    });
}